import dynamic from 'next/dynamic';
import ServerFooterColumnsWrapper from './ServerFooterColumnsWrapper';

const ClientFooterColumns = dynamic(() => import('./ClientFooterColumns'), {});

/**
 * FooterColumnsWrapper.
 */
const FooterColumnsWrapper = ({
  isPagesRouter,
}: {
  isPagesRouter?: boolean;
}) => {
  if (isPagesRouter) {
    return <ClientFooterColumns />;
  }
  return <ServerFooterColumnsWrapper />;
};

export default FooterColumnsWrapper;
